import React, { Component } from "react";
import { Link } from "react-router";
import Request from "superagent";

import { AWAY_TEAM, HOME_TEAM, GAME_KEY, GAME_NAME } from "./gameInfo";
import { API_BASE } from "./api";
import { NFL_TEAMS } from "./nfl";
import GrassPage from "./GrassPage";
import { COLOR_GRAY_STYLE, LINK_STYLE, GRASS_BODY } from "./styles";

import "./App.css";

const STYLE_CITY = {
  fontFamily: '"league-gothic",sans-serif',
  fontSize: 64,
  fontStyle: "italic",
  textTransform: "uppercase",
};
const STYLE_TEAM = {
  fontFamily: '"league-gothic",sans-serif',
  fontSize: 112,
  textTransform: "uppercase",
};
const STYLE_VS = Object.assign(
  {
    fontFamily: '"league-gothic",sans-serif',
    fontSize: 80,
    color: "#aaa",
  },
  COLOR_GRAY_STYLE,
);

const TEAM_DIV_STYLE = { lineHeight: 0.8 };

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      matchup: null,
    };
  }

  componentDidMount() {
    Request.get(`${API_BASE}/matchup`).end((err, res) => {
      const data = res && res.body && res.body.data;
      if (err || !data || !data.away || !data.home || !data.gamekey || !data.name) {
        this.setState({ loading: false, matchup: null });
        return;
      }
      this.setState({ loading: false, matchup: data });
    });
  }

  render() {
    if (this.state.loading) {
      return <div />;
    }

    const matchup =
      this.state.matchup || {
        away: AWAY_TEAM,
        home: HOME_TEAM,
        gamekey: GAME_KEY,
        name: GAME_NAME,
      };
    const away = NFL_TEAMS[matchup.away];
    const home = NFL_TEAMS[matchup.home];
    const styleAwayColor = { color: away.primaryColor };
    const styleHomeColor = { color: home.primaryColor };

    return (
      <GrassPage>
        <div style={GRASS_BODY}>
          <div
            style={{
              fontFamily: "league-gothic-condensed, sans-serif",
              fontSize: 120,
              color: "#aaa",
              textAlign: "center",
            }}
          >
            {matchup.name}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 30,
            }}
          >
            <div style={TEAM_DIV_STYLE}>
              <span style={Object.assign({ color: away.secondaryColor }, STYLE_CITY)}>
                {away.city}
              </span>
              <br />
              <span style={Object.assign({}, STYLE_TEAM, styleAwayColor)}>{away.name}</span>
            </div>
            <div style={STYLE_VS}>vs</div>
            <div style={TEAM_DIV_STYLE}>
              <span style={Object.assign({ color: home.secondaryColor }, STYLE_CITY)}>
                {home.city}
              </span>
              <br />
              <span style={Object.assign({}, STYLE_TEAM, styleHomeColor)}>{home.name}</span>
            </div>
          </div>
          <div
            style={{
              marginTop: 80,
              textAlign: "center",
            }}
          >
            <Link to="/about" className="ulh" style={LINK_STYLE}>
              how it works
            </Link>
            <Link
              to={`/create/${matchup.gamekey}`}
              className="ulh"
              style={Object.assign({ paddingLeft: 30 }, LINK_STYLE)}
            >
              start game
            </Link>
          </div>
        </div>
      </GrassPage>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js